import Api from './ApiWAService'

export default {
    getSummary(days = 7) {
        return Api().get(`whatsapp_monitor/summary?days=${days}`);
    },
    getFailures({ days = 7, pageNumber = 1, pageSize = 20, category = '' } = {}) {
        let url = `whatsapp_monitor/failures?days=${days}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
        if (category) url += `&category=${category}`;
        return Api().get(url);
    },
    getQueues() {
        return Api().get(`whatsapp_monitor/queues`);
    },
    // Visão agregada de mensagens/disparos para o dashboard
    getDashboard(days = 7) {
        return Api().get(`whatsapp_monitor/dashboard?days=${days}`);
    },
}
